// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linkcolor {\n  color: #023e8a;\n}\n\na {\n  color: #023e8a;\n}", "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/linkcoloractive.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".linkcolor {\n  color: #023e8a;\n}\n\na {\n  color: #023e8a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
